import React, { useState, useRef, useEffect } from 'react';
import Cookies from 'js-cookie';
import { NavLink } from 'react-router-dom';
import logo from '../../../assets/images/logo-123cloud.svg'
// import { getCredit } from '../../Service/CreditService'
import '../../../css/sidebar.css'
import styled from 'styled-components';
import { fetchRegions } from '../../Service/Region';
import { useDispatch, useSelector } from 'react-redux';
import { removeFromCart } from '../../../redux/cart/cartActions'; // Đảm bảo import action
import { getProfile } from '../../Service/UserService';
import { useNavigate, Link } from 'react-router-dom';
import { useProfile } from '../../../Context/ProfileContext';
import Spinner from 'react-bootstrap/Spinner';
import style from './HeaderCart.module.css';
import { getTotalCredit } from '../../Service/CreditService';
import "../../../i18n";
import { useTranslation } from "react-i18next";
import "./Header.css"
const userName = Cookies.get('UserName');
const REACT_APP_IMAGE_LOGO = process.env.REACT_APP_IMAGE_LOGO;
const Header = ({ toggleSidebar, handleSelectRegion }) => {

    const { t, i18n } = useTranslation();

    const changeLanguage = (lang) => {
        console.log("lang", lang)
        i18n.changeLanguage(lang);
        localStorage.setItem("language", lang);
    };

    useEffect(() => {
        const savedLang = localStorage.getItem("language") || "vi";
        i18n.changeLanguage(savedLang);
    }, []);



    const navigate = useNavigate();


    const { profile, loading } = useProfile();


    const handleLogout = () => {
        Cookies.remove('Token');
        Cookies.remove('UserName');
        Cookies.remove('email');
        navigate('/');
    };
    const handelProfile = () => {

        navigate('/account/update-info');
    };
    const [regions, setregions] = useState([])
    const token = Cookies.get('Token');
    const savedRegionId = Cookies.get("selectedRegion");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const [credit, setcredit] = useState(null);

    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev);
    };
    const closeDropdown = () => {
        setIsDropdownOpen(false);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };

        // Thêm lắng nghe sự kiện click
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup sự kiện khi component bị unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    // useEffect(() => {
    //     const fetchProfile = async () => {
    //         const response = await getProfile();
    //         setprofile(response?.user);
    //         localStorage.setItem('Balance', response?.user?.balance);
    //     };
    //     fetchProfile();
    // }, []);

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetchRegions()
            setregions(response)
            handleSelectRegion(response[0])
            const regionFromCookie = response.find(
                (region) => region.slug === savedRegionId
            );
            // console.log("regionFromCookie", regionFromCookie)

            if (regionFromCookie) {
                setSelectedLanguage(regionFromCookie);
                handleSelectRegion(regionFromCookie);
            } else {
                // Nếu không tìm thấy, chọn vùng mặc định
                setSelectedLanguage(response[0]);
                handleSelectRegion(response[0]);
            }
        }
        const fetchDataCredit = async () => {
            const response = await getTotalCredit();
            // console.log("responsecredit", response);
            if (response?.total_amount) {
                localStorage.setItem('credit', response.total_amount);
            }
            setcredit(response?.total_amount);
        }

        fetchData();
        fetchDataCredit();
    }, []
    )
    const [selectedLanguage, setSelectedLanguage] = useState({
        id: 1,
        slug: "vn",
        name: "US East (N. Virginia)",
        zone: "N. Virginia",
    });
    const handleSelectLanguage = (region) => {
        setSelectedLanguage({
            id: region.id,
            slug: region.slug,
            name: region.name,
            zone: region.zone,
        });
        handleSelectRegion(region)
    };
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const cartItems = useSelector((state) => state.cart.cartItems);

    // Tính tổng sản phẩm và giá trị giỏ hàng
    const dispatch = useDispatch();

    const totalItems = cartItems.reduce((total, item) => total + item.quantity, 0);
    const totalPrice = cartItems.reduce(
        (total, item) => total + item.quantity * item.price,
        0
    );
    const handleRemoveItem = (id) => {
        dispatch(removeFromCart(id)); // Gọi action để xóa item khỏi giỏ hàng
    };



    const username = Cookies.get("UserName");


    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div>

            <div style={{ paddingBottom: '54px' }} className="app-header navbar">
                {/* <button
                    className="navbar-toggler sidebar-toggler d-lg-none mr-auto"
                    type="button"
                    data-toggle="sidebar-show"
                    onClick={toggleSidebar}http://localhost:3000/cssp/create
                >
                    <span className="navbar-toggler-icon" />{" "}
                </button> */}


                <a
                    className="navbar-brand"
                    href="/dashboard"
                    style={{ display: isMobile ? "none" : "block", margin: "0px", paddingTop: "5px", backgroundColor: "white", padding: "0px" }}
                >

                    <div style={{ width: "100%", background: "white" }}>
                        <svg width="100%" height="100%" viewBox="37 85 1276 319" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M37 85H726V404H37V85Z" fill="#F2721E" />
                            <path d="M726 85H1313V404H726V85Z" fill="#040053" />
                            <path d="M161.5 332V185.5H106V157H248V185.5H192.5V332H161.5Z" fill="white" />
                            <path d="M282.359 332V157H313.109V332H282.359Z" fill="white" />
                            <path d="M359.955 332V157H425.205C480.205 157 518.205 194.75 518.205 244V244.5C518.205 293.75 480.205 332 425.205 332H359.955ZM390.705 304H425.205C461.955 304 485.955 279.25 485.955 245V244.5C485.955 210.25 461.955 185 425.205 185H390.705V304Z" fill="white" />
                            <path d="M528.549 332L605.5 157H634L711.049 332H678.549L660.799 289.75H578.049L560.049 332H528.549ZM589.299 262.5H649.549L619.299 192.5L589.299 262.5Z" fill="white" />
                            <path d="M741.059 332V157H806.309C861.309 157 899.309 194.75 899.309 244V244.5C899.309 293.75 861.309 332 806.309 332H741.059ZM771.809 304H806.309C843.059 304 867.059 279.25 867.059 245V244.5C867.059 210.25 843.059 185 806.309 185H771.809V304Z" fill="white" />
                            <path d="M938.365 332V157H969.115V332H938.365Z" fill="white" />
                            <path d="M1098.96 335C1044.21 335 1008.21 296 1008.21 245V244.5C1008.21 195.5 1045.71 154 1098.46 154C1128.96 154 1147.71 162.5 1165.71 177.75L1146.21 201C1132.71 189.5 1119.46 182.25 1097.21 182.25C1064.96 182.25 1040.46 210.5 1040.46 244V244.5C1040.46 280.5 1064.21 307 1099.96 307C1116.46 307 1131.46 301.75 1142.21 293.75V261H1097.46V234.25H1171.96V307.75C1154.71 322.5 1129.96 335 1098.96 335Z" fill="white" />
                            <path d="M1213.76 332V157H1244.51V332H1213.76Z" fill="white" />
                        </svg>
                    </div>
                </a>
                <button
                    style={{ marginLeft: "10px" }}
                    className="navbar-toggler sidebar-toggler d-md-down-none"
                    type="button"
                    data-toggle="sidebar-lg-show"
                    onClick={toggleSidebar}
                    onFocus={(e) => {
                        e.currentTarget.style.outline = 'none';
                        e.currentTarget.style.boxShadow = 'none';
                        e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                    onBlur={(e) => {
                        e.currentTarget.style.outline = 'none';
                        e.currentTarget.style.boxShadow = 'none';
                        e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                >
                    <svg
                        stroke="currentColor"
                        fill="black"
                        strokeWidth={0}
                        viewBox="0 0 17 17"
                        aria-hidden="true"
                        className="h-6 w-6"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fillRule="evenodd"
                            d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1z"
                            clipRule="evenodd"
                        />
                    </svg>
                    {/* hihi */}
                </button>

                <ul className="nav navbar-nav nav-lang">
                    <li className="nav-item dropdown">
                        <div
                            data-toggle="dropdown"
                            role="button"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span className="lang-title-current">{selectedLanguage.name}</span>
                            <span className="icon-down">
                                <svg
                                    stroke="currentColor"
                                    fill="none"
                                    strokeWidth={2}
                                    viewBox="0 0 24 24"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="h-4 transform"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <polyline points="6 9 12 15 18 9" />
                                </svg>
                            </span>
                        </div>
                        <div
                            style={{ width: "300px" }}
                            className="dropdown-menu dropdown-menu-left"
                        >
                            {regions.map((r, index) => (
                                <a
                                    key={index}
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => handleSelectLanguage(r)}
                                >
                                    <span>{r.zone}</span> {r.name}
                                </a>
                            ))}
                        </div>
                    </li>
                </ul>
                <button onClick={() => changeLanguage("en")} style={{
                    background: "none", border: "none", cursor: "pointer", margin: "0px", padding: "2px", borderBottom: i18n.language === "en" ? "2px solid #0069ff" : "none"
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="20" viewBox="0 0 7410 3900">
                        <path d="M0,0h7410v3900H0" fill="#b31942" />
                        <path d="M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0" stroke="#FFF" strokeWidth="300" />
                        <path d="M0,0h2964v2100H0" fill="#0a3161" />
                        <g fill="#FFF">
                            <g id="s18">
                                <g id="s9">
                                    <g id="s5">
                                        <g id="s4">
                                            <path id="s" d="M247,90 317.534230,307.082039 132.873218,172.917961H361.126782L176.465770,307.082039z" />
                                            <use xlinkHref="#s" y="420" />
                                            <use xlinkHref="#s" y="840" />
                                            <use xlinkHref="#s" y="1260" />
                                        </g>
                                        <use xlinkHref="#s" y="1680" />
                                    </g>
                                    <use xlinkHref="#s4" x="247" y="210" />
                                </g>
                                <use xlinkHref="#s9" x="494" />
                            </g>
                            <use xlinkHref="#s18" x="988" />
                            <use xlinkHref="#s9" x="1976" />
                            <use xlinkHref="#s5" x="2470" />
                        </g>
                    </svg>
                </button>

                <button onClick={() => changeLanguage("vi")} style={{
                    background: "none", border: "none", cursor: "pointer", margin: "0px", padding: "0px", paddingRight: "1px", borderBottom: i18n.language === "vi" ? "2px solid #0069ff" : "none"
                }}>
                    <svg width="30" height="18" viewBox="0 0 30 20">
                        <rect width="33" height="20" fill="#da251d" />
                        <polygon points="15,4 11.47,14.85 20.71,8.15 9.29,8.15 18.53,14.85" fill="#ff0" />
                    </svg>
                </button>

                <ul className="nav navbar-nav nav-right ml-auto">
                    <li>
                        <div
                            className="head-create"
                            style={{
                                backgroundColor: "#0069ff",
                                color: "white",
                                borderRadius: "20px",
                                textDecoration: "none",
                                paddingLeft: "20px",
                                paddingRight: "20px",
                                paddingTop: "3px",
                                paddingBottom: "3px",
                                marginRight: "10px",
                            }}
                        >
                            <span className="text-create">
                                <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth={0}
                                    viewBox="0 0 16 16"
                                    className="mr-1"
                                    height="0.8em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                    />
                                </svg>{" "}
                                <a
                                    style={{
                                        color: "white",
                                        textDecoration: "none",
                                        paddingRight: "5px",
                                        fontSize: "13px",
                                    }}
                                    href="/recharge"
                                >
                                    <b>{t("Add funds")}</b>
                                </a>
                            </span>
                        </div>
                    </li>


                    <li className="nav-item dropdown nav-create">
                        {/* Phần chính để mở dropdown */}
                        <div
                            className="head-create"
                            onClick={toggleDropdown} // Toggle dropdown khi click
                            role="button"
                            aria-haspopup="true"
                            aria-expanded={isDropdownOpen}
                        >
                            <span className="text-create">
                                <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth={0}
                                    viewBox="0 0 16 16"
                                    className="mr-1"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                    />
                                </svg>{" "}
                                {t("Deploy")}{" "}
                                <svg
                                    stroke="currentColor"
                                    fill="none"
                                    strokeWidth={2}
                                    viewBox="0 0 24 24"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className={`h-4 transform ${isDropdownOpen ? "rotate-180" : ""}`}
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <polyline points="6 9 12 15 18 9" />
                                </svg>
                            </span>
                        </div>

                        {isDropdownOpen && (
                            <div ref={dropdownRef} className="dropdown-menu dropdown-menu-right show">

                                <Link
                                    to="/cssp/create"
                                    className="dropdown-item menu-item"
                                    onClick={closeDropdown}
                                >
                                    <svg
                                        stroke="currentColor"
                                        fill="none"
                                        strokeWidth={2}
                                        viewBox="0 0 24 24"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="icon"
                                        height="1em"
                                        width="1em"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{ position: "relative", top: "-2px" }}
                                    >
                                        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                                        <line x1={3} y1={6} x2={21} y2={6} />
                                        <path d="M16 10a4 4 0 0 1-8 0" />
                                    </svg> CSSP
                                </Link>

                                <Link
                                    to="/cshp/create"
                                    className="dropdown-item menu-item"
                                    onClick={closeDropdown}
                                >
                                    <svg
                                        stroke="currentColor"
                                        fill="none"
                                        strokeWidth="2"
                                        viewBox="0 0 24 24"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="icon"
                                        height="1em"
                                        width="1em"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={{ position: "relative", top: "-2px" }}
                                    >
                                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"></circle>
                                        <line x1="12" y1="6" x2="12" y2="12" stroke="currentColor" strokeWidth="2"></line>
                                        <line x1="12" y1="12" x2="16" y2="12" stroke="currentColor" strokeWidth="2"></line>
                                    </svg> CSHP
                                </Link>
                            </div>

                        )}

                    </li>
                    <li className="">
                        <div
                            className="head-create"
                            href="#"
                            style={{ backgroundColor: "#0069ff", color: "white", borderRadius: "20px", textDecoration: "none", paddingLeft: "20px", paddingRight: "20px", paddingTop: "3px", paddingBottom: "3px", marginRight: "10px" }}



                        >
                            <span className="text-create">
                                <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth={0}
                                    viewBox="0 0 16 16"
                                    className="mr-1"
                                    height="0.8em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                    />
                                </svg>{" "}
                                <a style={{ color: "white", textDecoration: "none", paddingRight: "5px", fontSize: "13px" }} href='/tickets/add'><b>{t("Open ticket")}</b></a>
                            </span>

                        </div>

                    </li>


                    <div id="cart-icon"
                        className={style.carticon} onClick={() => setDropdownOpen(!dropdownOpen)}>
                        <i className="fas fa-shopping-cart"></i>
                        <span className={style.cartcount}>{totalItems}</span>
                    </div>

                    {dropdownOpen && (
                        <div className={style.cartdropdown}>
                            <ul className={style.cartitems}>
                                {cartItems.map((item) => (
                                    <li key={item.id} className={style.cartitem}>
                                        <div className={style.cartitemdetails}>
                                            <span className={style.itemname}>{item.name}</span>
                                            <div className={style.iteminfo}>
                                                <span className={style.itemquantity}>{item.quantity} x </span>
                                                <span className={style.itemprice}>{item.price.toLocaleString('vi-VN')}</span>
                                                <button className={style.removeitembtn} onClick={() => handleRemoveItem(item.id)}>
                                                    &times;
                                                </button>
                                            </div>

                                        </div>
                                    </li>
                                ))}
                            </ul>
                            {/* <div className={style.carttotal}>
                                <span>Tổng cộng: {totalPrice.toLocaleString('vi-VN')} </span>
                            </div> */}
                            <div style={{ width: "100%" }} >
                                <NavLink to="/cart">
                                    <button style={{ width: "100%" }} className="btn btn-primary">Xem Giỏ Hàng</button>
                                </NavLink>
                                {/* <NavLink to="/checkout">
                                    <button className={style.checkoutButton}>Thanh Toán</button>
                                </NavLink> */}
                            </div>
                        </div>
                    )}


                    <li className="nav-item nav-balance">
                        {" "}
                        <span className="text-balance">
                            {t("CREDIT")}: {credit !== "null"
                                ? parseFloat(credit).toLocaleString('vi-VN', {

                                })
                                : (0).toLocaleString('vi-VN', {

                                })} <br />

                            <strong>
                                {t("BALANCE")}: {(profile?.balance ? parseFloat(profile.balance) : 0).toLocaleString('vi-VN',
                                    {
                                    }

                                )}
                            </strong>

                        </span>{" "}
                    </li>
                    <li className="nav-item nav-avatar">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            height="40px"
                            width="40px"
                            version="1.1"
                            id="Layer_1"
                            viewBox="0 0 331.594 331.594"
                            xmlSpace="preserve"
                        >
                            <g id="XMLID_3_">
                                <g id="XMLID_62_">
                                    <g id="XMLID_1228_">
                                        <path
                                            id="XMLID_1229_"
                                            style={{ fill: "#F3D8B6" }}
                                            d="M248.986,236.042c-18.667-6.681-51.458-11.736-51.458-81.376h-29.23h-5.002     h-29.23c0,69.64-32.791,74.695-51.458,81.376c0,47.368,68.832,48.824,80.688,53.239v1.537c0,0,0.922-0.188,2.501-0.68     c1.579,0.492,2.501,0.68,2.501,0.68v-1.537C180.153,284.866,248.986,283.409,248.986,236.042z"
                                        />
                                    </g>
                                    <path
                                        id="XMLID_1230_"
                                        style={{ fill: "#EEC8A2" }}
                                        d="M197.528,154.666h-29.23h-2.501v135.472c1.579,0.491,2.501,0.68,2.501,0.68    v-1.537c11.856-4.414,80.688-5.871,80.688-53.239C230.319,229.361,197.528,224.306,197.528,154.666z"
                                    />
                                </g>
                                <g id="XMLID_55_">
                                    <path
                                        id="XMLID_1233_"
                                        style={{ fill: "#545465" }}
                                        d="M285.326,290.913v40.681H45.363v-40.681c0-30.431,17.377-56.963,40.605-70.913    c6.043-3.641,19.69-7.43,26.844-9.196c5.953-1.488,53.438,12.729,53.438,12.729s48.674-13.218,54.627-11.729    c7.154,1.766,17.802,4.554,23.844,8.196C267.949,233.951,285.326,260.482,285.326,290.913z"
                                    />
                                    <path
                                        id="XMLID_1236_"
                                        style={{ fill: "#494857" }}
                                        d="M245.627,220c-6.042-3.641-19.69-7.43-26.844-9.196    c-5.953-1.488-52.533,12.729-52.533,12.729l0,0v108.06h119.982v-40.681C286.232,260.482,268.854,233.951,245.627,220z"
                                    />
                                </g>
                                <g id="XMLID_52_">
                                    <path
                                        id="XMLID_1237_"
                                        style={{ fill: "#F3DBC4" }}
                                        d="M165.799,176.828c-27.454,0-48.409-23.119-57.799-40.456    s-15.888-79.445,4.34-106.897c19.808-26.883,53.459-13.838,53.459-13.838s33.649-13.045,53.458,13.838    c20.226,27.452,13.726,89.56,4.335,106.897C214.2,153.709,193.247,176.828,165.799,176.828z"
                                    />
                                    <path
                                        id="XMLID_1238_"
                                        style={{ fill: "#EDCEAE" }}
                                        d="M219.257,29.476c-19.81-26.883-53.458-13.838-53.458-13.838h-0.002v161.191    c0.001,0,0.001,0,0.002,0c27.449,0,48.401-23.119,57.794-40.456C232.983,119.036,239.483,56.928,219.257,29.476z"
                                    />
                                </g>
                                <g id="XMLID_45_">
                                    <path
                                        id="XMLID_1241_"
                                        style={{ fill: "#545465" }}
                                        d="M223.252,25.321c-2.159,0.08-12.282-31.303-39.282-24.303    c-18.537,4.806-20.877,7.419-28.12,9.463c-29.41-9.014-57.539,14.472-56.495,36.488c1.759,37.07-4.778,36.505-0.295,49.454    s8.466,23.407,8.466,23.407s0.996,3.565,2.988-16.854s-4.705-31.379,11.137-31.379c52.452,0-19.698,20.372,13.952,20.372    c33.391,0,59.203-27.381,74.92-29.372c15.716-1.992,9.145,19.96,11.137,40.379s2.988,16.854,2.988,16.854s8.92-9.712,8.466-23.407    C232.604,80.969,239.484,24.719,223.252,25.321z"
                                    />
                                    <path
                                        id="XMLID_1244_"
                                        style={{ fill: "#494857" }}
                                        d="M223.252,25.322c-2.159,0.08-12.282-31.303-39.282-24.303    c-9.171,2.377-14.375,4.218-18.173,5.719V85.04c18.973-8.253,34.142-21.103,44.726-22.443c15.717-1.992,9.145,19.96,11.137,40.379    s2.988,16.854,2.988,16.854s8.92-9.712,8.466-23.407C232.604,80.969,239.484,24.719,223.252,25.322z"
                                    />
                                </g>
                                <g id="XMLID_42_">
                                    <ellipse
                                        id="XMLID_44_"
                                        transform="matrix(0.3543 -0.9351 0.9351 0.3543 45.161 283.6375)"
                                        style={{ fill: "#EDCEAE" }}
                                        cx="227.971"
                                        cy="109.116"
                                        rx="17.187"
                                        ry="10.048"
                                    />
                                    <ellipse
                                        id="XMLID_43_"
                                        transform="matrix(0.3543 0.9351 -0.9351 0.3543 168.9501 -26.4359)"
                                        style={{ fill: "#F3DBC4" }}
                                        cx="103.618"
                                        cy="109.124"
                                        rx="17.187"
                                        ry="10.048"
                                    />
                                </g>
                                <g id="XMLID_38_">
                                    <g id="XMLID_1245_">
                                        <polygon
                                            id="XMLID_1246_"
                                            style={{ fill: "#FFFFFF" }}
                                            points="213.458,331.594 118.136,331.594 118.136,204.664 165.797,218.388      213.458,204.664    "
                                        />
                                    </g>
                                    <polygon
                                        id="XMLID_1247_"
                                        style={{ fill: "#DFE0E7" }}
                                        points="165.797,218.388 165.797,331.594 213.458,331.594 213.458,204.664   "
                                    />
                                </g>
                                <g id="XMLID_4_">
                                    <path
                                        id="XMLID_35_"
                                        style={{ fill: "#494857" }}
                                        d="M126.777,201.164c0,0-32.452,8.501-39.684,18.626    c-7.232,10.124-11.571,23.865-11.571,23.865l28.204,10.124l-20.887,20.344l28.811,57.366h26.791c0,0-20.868-72.454-21.331-97.992    C116.959,225.13,126.777,201.164,126.777,201.164z"
                                    />
                                    <path
                                        id="XMLID_1251_"
                                        style={{ fill: "#3B3A47" }}
                                        d="M204.817,201.164c0,0,32.452,8.501,39.684,18.626    c7.232,10.124,11.571,23.865,11.571,23.865l-28.204,10.124l20.887,20.344l-28.15,57.366h-26.791c0,0,20.207-72.454,20.669-97.992    C214.635,225.13,204.817,201.164,204.817,201.164z"
                                    />
                                </g>
                            </g>
                        </svg>
                    </li>


                    <li className="nav-item dropdown nav-account-name no-hover">
                        <a
                            className="nav-link dropdown-toggle no-hover"
                            data-bs-toggle="dropdown"
                            href="#"
                            role="button"
                            aria-haspopup="true"
                            aria-expanded="false"
                            onClick={(e) => e.preventDefault()} // Ngăn chặn hành vi mặc định của thẻ <a>
                        >
                            {/* <svg
                                stroke="currentColor"
                                fill="none"
                                strokeWidth={2}
                                viewBox="0 0 24 24"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="h-4 transform"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <polyline points="6 9 12 15 18 9" />
                            </svg> */}
                            <span className="account-name">{t("Hello")}, {profile?.name} </span>
                        </a>
                        <div style={{ marginLeft: "0px", marginTop: "20px" }} className="dropdown-menu dropdown-menu-right">
                            <a
                                className="dropdown-item"
                                href=""
                                onClick={(e) => {
                                    e.preventDefault();
                                    handelProfile(); // Gọi hàm logout
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    height="18"
                                    width="18"
                                >
                                    <circle cx="12" cy="8" r="4"></circle>
                                    <path d="M16 14c-1.33-1-3.33-1-4 0-1.33-1-3.33-1-4 0v3h8v-3z"></path>
                                </svg>

                                Profile
                            </a>
                            <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleLogout(); // Gọi hàm logout
                                }}
                            >
                                <svg
                                    stroke="currentColor"
                                    fill="none"
                                    strokeWidth={2}
                                    viewBox="0 0 24 24"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    height={18}
                                    width={18}
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                    <polyline points="16 17 21 12 16 7" />
                                    <line x1={21} y1={12} x2={9} y2={12} />
                                </svg>
                                Thoát
                            </a>
                        </div>
                    </li>

                </ul>



                <div
                    className="header-menu-right only-mobile"
                    style={{ position: "fixed", top: 70, right: 0 }}
                >

                    <div
                        className="box action-notifi"
                        data-toggle="tooltip"
                        data-placement="left"
                        data-original-title="Thông báo"
                    >
                        <svg
                            stroke="currentColor"
                            fill="none"
                            strokeWidth={2}
                            viewBox="0 0 24 24"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="text-[#828282]"
                            height={18}
                            width={18}
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                        </svg>
                        <span style={{ color: "red", marginLeft: "-15px", marginRight: 10 }}>
                            <sup>(0)</sup>
                        </span>
                    </div>

                    <div
                        className="box action-contact"
                        data-toggle="tooltip"
                        data-placement="left"
                        data-original-title="Hỗ trợ"
                    >
                        <svg
                            stroke="currentColor"
                            fill="none"
                            strokeWidth={2}
                            viewBox="0 0 24 24"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="text-[#828282] group-hover:text-gray-500"
                            height={16}
                            width={16}
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                        </svg>
                    </div>
                    <div
                        className="box box-last"
                        id="scrollTop"
                        data-toggle="tooltip"
                        data-placement="left"
                        data-original-title="Lên trên"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                            {/*!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}
                            <path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z" />
                        </svg>
                    </div>
                </div>
            </div >
        </div >

    );
}

export default Header;
